import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common'


@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
})
export class NotFoundComponent {

  constructor(private location : Location) { }
  

  ngOnInit(): void {
  }

   
  goBack(){
    this.location.back();
  }
}
